import { render, staticRenderFns } from "./VerificationsListPage.vue?vue&type=template&id=39a3687e&"
import script from "./VerificationsListPage.vue?vue&type=script&lang=js&"
export * from "./VerificationsListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a3687e')) {
      api.createRecord('39a3687e', component.options)
    } else {
      api.reload('39a3687e', component.options)
    }
    module.hot.accept("./VerificationsListPage.vue?vue&type=template&id=39a3687e&", function () {
      api.rerender('39a3687e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/VerificationsListPage.vue"
export default component.exports